// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yk2PP","colBig":"styles_colBig__NhKJC","colSmall":"styles_colSmall__1hsyi"};